import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'rwidget-challenge-message',
    templateUrl: './challenge-message.component.html',
    styleUrls: ['./challenge-message.component.scss']
})
export class ChallengeMessageComponent {
    @Input() verificationCode?: string;
    @Output() onCancel = new EventEmitter<void>();

    cancel() {
        this.onCancel.emit();
    }
}
